var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitalyst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 175.34 61.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#55565a;}.cls-2{fill:#f9a11b;}.cls-3{fill:#d8272d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.09 10.64 14.42 38.96 14.27 38.96 4.53 10.64 0 10.64 12.44 46.77 16.24 46.77 28.63 10.64 24.09 10.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.14,
    y: 20.96,
    width: 4.08,
    height: 25.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.16,15.21h4.07V21h8v3.79h-8V38.37c0,3.53,1,5,4.06,5h3.92v3.82H46.29c-5.85,0-8.13-3.45-8.13-8.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.55,
    y: 10.64,
    width: 4.08,
    height: 36.14
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "105.95 20.96 91.18 61.56 86.88 61.56 92.57 45.79 83.48 20.96 87.74 20.96 94.72 39.94 101.64 20.96 105.95 20.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.67,21v3.8h-9.49c-3,0-4.92,1-5,3.51,0,2.11,1.89,3.06,5,3.38.75.05,1.52.19,2,.22,5.26.57,8.25,3.15,8.25,7.39,0,5.75-4.2,7.84-9.76,7.84H100.9l1.39-3.79h14.43c3.94,0,5.72-1.05,5.72-4.05,0-2.11-1.26-3.24-4.6-3.61l-2.06-.22c-4.67-.51-8.59-2.41-8.59-7.16,0-5.33,4.45-7.31,9-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.65,15.21h4.07V21H144v3.79H133.72V38.37c0,3.53,1,5,4.06,5h3.92v3.82h-3.92c-5.85,0-8.13-3.45-8.13-8.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.38,34.74v-6c0-4.35-3-7.74-7.45-7.74H54.32v3.79H64.93c2,0,3.37,1.61,3.37,3.95v2.73H60.53a7.68,7.68,0,1,0,0,15.35h2.95c5.23,0,8.9-4.26,8.9-9.42V34.74ZM68.3,37.36c0,3.2-2.1,5.58-4.82,5.58H60.53a3.73,3.73,0,0,1-3.69-3.81,3.77,3.77,0,0,1,3.69-3.86H68.3v2.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.77 52.49 44.77 61.56 43.68 61.56 43.68 57.53 39.26 57.53 39.26 61.56 38.17 61.56 38.17 52.49 39.26 52.49 39.26 56.51 43.68 56.51 43.68 52.49 44.77 52.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.09 52.49 52.09 53.51 47.57 53.51 47.57 56.35 51.38 56.35 51.38 57.37 47.57 57.37 47.57 60.54 52.09 60.54 52.09 61.56 46.49 61.56 46.49 52.49 52.09 52.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.46,52.49l3.23,9.07H59.55l-.86-2.4H55.25l-.84,2.4H53.28l3.21-9.07ZM57,54.4h-.05l-1.32,3.74h2.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.18 52.49 63.18 60.54 67.3 60.54 67.3 61.56 62.1 61.56 62.1 52.49 63.18 52.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.7 52.49 72.7 53.47 69.91 53.47 69.91 61.56 68.83 61.56 68.83 53.47 65.99 53.47 65.99 52.49 72.7 52.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "80.62 52.49 80.62 61.56 79.54 61.56 79.54 57.53 75.11 57.53 75.11 61.56 74.03 61.56 74.03 52.49 75.11 52.49 75.11 56.51 79.54 56.51 79.54 52.49 80.62 52.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.54 52.49 106.54 53.51 102.02 53.51 102.02 56.35 105.82 56.35 105.82 57.37 102.02 57.37 102.02 61.56 100.94 61.56 100.94 52.49 106.54 52.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.48,52.41c1.89,0,3.14.92,3.14,3.2v2.92a2.91,2.91,0,0,1-3.14,3.12h-.56a2.92,2.92,0,0,1-3.15-3.12V55.61c0-2.28,1.25-3.2,3.15-3.2Zm2.06,3.2c0-1.62-.72-2.18-2.06-2.18h-.56c-1.34,0-2.07.56-2.07,2.18v2.92a1.91,1.91,0,0,0,2.07,2.11h.56a1.91,1.91,0,0,0,2.06-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.78,52.49v6.43c0,1.6-.88,2.74-2.4,2.74H118.9a2.5,2.5,0,0,1-2.5-2.74V52.49h1.08v6.43c0,1.16.65,1.73,1.42,1.73h1.48c.82,0,1.32-.63,1.32-1.73V52.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.39 52.49 131.39 61.56 130.48 61.56 125.77 54.56 125.77 61.56 124.69 61.56 124.69 52.49 125.66 52.49 130.31 59.4 130.31 52.49 131.39 52.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.57,52.49c1.9,0,3.15.92,3.15,3.2v2.74a2.93,2.93,0,0,1-3.15,3.13H133.4V52.49Zm2.06,3.2c0-1.62-.72-2.18-2.06-2.18h-2.09v7h2.09a1.9,1.9,0,0,0,2.06-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.53,52.5l3.24,9.06h-1.14l-.86-2.4h-3.45l-.83,2.4h-1.14l3.21-9.06Zm-.47,1.9H144l-1.32,3.74h2.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "153.86 52.49 153.86 53.47 151.06 53.47 151.06 61.56 149.98 61.56 149.98 53.47 147.15 53.47 147.15 52.49 153.86 52.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.04,
    y: 52.49,
    width: 1.08,
    height: 9.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.61,52.41c1.89,0,3.14.92,3.14,3.2v2.92a2.92,2.92,0,0,1-3.14,3.12h-.56a2.92,2.92,0,0,1-3.15-3.12V55.61c0-2.28,1.25-3.2,3.15-3.2Zm2.06,3.2c0-1.62-.72-2.18-2.06-2.18h-.56c-1.35,0-2.07.56-2.07,2.18v2.92a1.91,1.91,0,0,0,2.07,2.11h.56a1.91,1.91,0,0,0,2.06-2.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "173.13 52.49 173.13 61.56 172.23 61.56 167.52 54.56 167.52 61.56 166.44 61.56 166.44 52.49 167.41 52.49 172.05 59.4 172.05 52.49 173.13 52.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.6,23.54H150.14a.67.67,0,1,1,0-1.34H170.6a.67.67,0,0,1,0,1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.67,23.54h-1.86a.67.67,0,1,1,0-1.34h1.86a.67.67,0,0,1,0,1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.91,30l-8-4.26a.68.68,0,0,1-.28-.91.67.67,0,0,1,.91-.28l8,4.26a.69.69,0,0,1,.28.92.68.68,0,0,1-.91.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.5,31.94l-1.64-.88a.67.67,0,0,1-.28-.91.68.68,0,0,1,.92-.27l1.64.87a.67.67,0,0,1,.27.91.68.68,0,0,1-.91.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.79,37.07l-1-9.06a.67.67,0,1,1,1.33-.14l1,9.06a.67.67,0,1,1-1.34.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.21,41.12,148,39.27a.67.67,0,0,1,1.34-.14l.19,1.85a.67.67,0,1,1-1.34.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.91,15.68l-8,4.27a.67.67,0,0,0-.28.91.69.69,0,0,0,.91.28l8-4.27a.68.68,0,0,0,.28-.91.67.67,0,0,0-.91-.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.5,13.77l-1.64.87a.67.67,0,0,0-.28.91.69.69,0,0,0,.92.28l1.64-.87a.68.68,0,0,0,.27-.92.67.67,0,0,0-.91-.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.79,8.63l-1,9.06a.67.67,0,1,0,1.33.14l1-9a.67.67,0,0,0-1.34-.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.21,4.58,148,6.43a.67.67,0,0,0,1.34.14l.19-1.85A.67.67,0,0,0,149,4a.68.68,0,0,0-.74.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.11,4.43l-11.45,17a.67.67,0,1,1-1.11-.75L159,3.67a.68.68,0,0,1,.94-.18.69.69,0,0,1,.18.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.38,1.05l-1,1.54a.68.68,0,0,1-.94.18.66.66,0,0,1-.18-.93l1-1.54a.67.67,0,1,1,1.11.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159,42.05l-11.44-17a.67.67,0,1,1,1.11-.75l11.44,17a.67.67,0,1,1-1.11.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.26,45.43l-1-1.54a.67.67,0,1,1,1.11-.75l1,1.54a.67.67,0,0,1-1.11.75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalyst);
export default __webpack_public_path__ + "static/media/vitalyst.1dd559dea91c28482f7db1479f700379.svg";
export { ForwardRef as ReactComponent };